import React from 'react';
import data from '../../legal-content/service-fees.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const ServicesFreePage = () => <LegalDocument data={data} currentPage="ServicesFreePage" />;

export default ServicesFreePage;
